/**
 * Created by Ning Jiang on 2022-03-08.
 */

import {SerialSymbolState} from "./SerialSymbolConfig";
import {gsap} from "gsap";
import {Serial} from "../Serial";
import {SerialSound} from "../sound/SerialSound";
import {MaskedSymbol} from "./MaskedSymbol";

export class SingleWildSymbol extends MaskedSymbol {

    private _landingSpine:PIXI.spine.Spine;
    private _landingTl:TimelineLite;

    constructor(symbolName:string, reelId:number, symbolHeight:number, initState:SerialSymbolState) {
        const names = symbolName.split(":");
        super(names[0], reelId, symbolHeight, initState);
    }

    public playLanding():gsap.core.Animation {
        if(!this._landingSpine) {
            this._landingSpine = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset("wild"));
            this._landingSpine.autoUpdate = true;
            this._landingSpine.position.set(this._centerPosition.x, this._animation.y);
            this.addChild(this._landingSpine);
            if(this._heightMask) {
                this._landingSpine.mask = this._heightMask;
            }
        }
        const tl = gsap.timeline();
        tl.add(() => {
            this.updateLayers();
            SerialSound.soundPlayer.playTrack({name : SerialSound.WILD_LANDING});
        });
        tl.add([
            () => {this._landingSpine.state.setAnimation(0, "Landing", false)},
            this.getStateAnimation(SerialSymbolState.NORMAL,
                {duration : 0.1, alpha : 1},
                {duration : 0.1, alpha : 0})
        ]);
        tl.add(() => {
                this.removeChild(this._landingSpine);
                this._landingSpine.destroy();
            },
            this._landingSpine.spineData.findAnimation("Landing").duration);
        this._landingTl = tl;
        return gsap.timeline();
    }

    public getLandingState():SerialSymbolState {
        return SerialSymbolState.LAND;
    }

    protected getStateColorChangeAnimation(tint:number):TimelineLite {
        const tl = super.getStateColorChangeAnimation(tint);
        if(this._currentState === SerialSymbolState.NO_WIN) {
            tl.add(() => {
                if(this._landingTl && this._landingTl.isActive()) {
                    this._landingTl.progress(1);
                }
            }, 0);
        }
        return tl;
    }

    public onRemove() {
        if(this._landingTl && this._landingTl.isActive()) {
            this._landingTl.pause();
            this._landingTl.kill();
        }
        super.onRemove();
    }
}